import { AuthService } from './../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-admin-pymes',
  templateUrl: './login-admin-pymes.component.html',
  styleUrls: ['./login-admin-pymes.component.css']
})
export class LoginAdminPymesComponent implements OnInit {

  usuario:string;
  password:string;
  primerIntento:boolean=true;
  tipo:string;

  constructor(private auth:AuthService, private router:Router, private activatedRoute:ActivatedRoute) {
    
    
  
    if(this.auth.isAuthenticated()){
      
      this.router.navigate(['home']);
    }
  }

  ngOnInit() {
  }

  loginAdminPymes(){
    this.auth.loginAdminPyme(this.usuario,this.password).subscribe(resp=>{
      
      if(resp==true){
        this.router.navigate(["/home"]);
      }else{
        this.primerIntento=false;
        this.usuario="";
        this.password="";
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login-admin-pymes/login-admin-pymes.component.ts